import { useEffect } from "react";

const SITE_ORIGIN = "https://www.edtech-depot.com";
const DEFAULT_OG_IMAGE = `${SITE_ORIGIN}/og-image.png`;

/**
 * Sets per-page SEO: title, meta description, canonical URL, and Open Graph /
 * Twitter Card tags. Keeps the SPA indexable + makes shared links preview
 * cleanly in iMessage, Slack, LinkedIn, Facebook, X, etc.
 */
function upsertMeta(selector, createAttrs, content) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    Object.entries(createAttrs).forEach(([k, v]) => el.setAttribute(k, v));
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function useSeo({ title, description, path, image }) {
  useEffect(() => {
    if (title) {
      document.title = title;
      upsertMeta('meta[property="og:title"]', { property: "og:title" }, title);
      upsertMeta('meta[name="twitter:title"]', { name: "twitter:title" }, title);
    }

    if (description) {
      upsertMeta(
        'meta[name="description"]',
        { name: "description" },
        description,
      );
      upsertMeta(
        'meta[property="og:description"]',
        { property: "og:description" },
        description,
      );
      upsertMeta(
        'meta[name="twitter:description"]',
        { name: "twitter:description" },
        description,
      );
    }

    if (path) {
      const href = `${SITE_ORIGIN}${path}`;
      let link = document.head.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", href);
      upsertMeta('meta[property="og:url"]', { property: "og:url" }, href);
    }

    const imgUrl = image || DEFAULT_OG_IMAGE;
    upsertMeta('meta[property="og:image"]', { property: "og:image" }, imgUrl);
    upsertMeta(
      'meta[name="twitter:image"]',
      { name: "twitter:image" },
      imgUrl,
    );
  }, [title, description, path, image]);
}
